import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { CaAnalysisDialogState } from '../ca-analysis-dialog.state';

import { RememberStatusChange } from './remember-status-change.action';

export function rememberStatusChangeReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<
        ActionType.COACHING__CA__CHANGE_TRANSCRIPT_STATUS,
        RememberStatusChange
    >,
): CaAnalysisDialogState {
    return {
        ...state,
        statuses: [...state.statuses, action.payload.status],
    };
}
